<template>
    <div class="row">
        <div class="col-12" v-if="displayType == 'list'">
            <ul>
                <li v-for="file in files">
                    <a :href="`/files/${(file.download_only ? 'download' : 'view')}/${file.file_id}`" target="_blank">
                        {{ file.file_name }}
                    </a>
                    | <a href="javascript:void(0)" class="text-danger ml-1" v-on:click="deleteFile(file)"><i class="fa fa-trash"></i> Delete</a>
                </li>
            </ul>
        </div>
        <div class="col-12" v-if="displayType == 'table'">
            <v-client-table ref="fileCompTableList" :data="files" :columns="fileTableColumns" :options="fileTableOptions">
                <template slot="file_name" slot-scope="props">
                    <a :href="`/files/view/${props.row.file_id}`" v-if="!props.row.download_only" target="_blank">{{ props.row.file_name }}</a>
                    <a :href="`/files/download/${props.row.file_id}`" v-else target="_blank">{{ props.row.file_name }}</a>
                </template>

                <template slot="user_id" slot-scope="props">
                    {{ props.row.FirstName }} {{ props.row.LastName }}
                </template>

                <template slot="created_at" slot-scope="props">
                    {{ props.row.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
                </template>
            </v-client-table>
        </div>

        <template v-else-if="displayType == 'blocks'">
            <div class="col-lg-3 col-md-4 col-sm-6 col-12 mb-lg-0 mb-2" v-for="file in files">
                <a :href="`/files/${(file.download_only ? 'download' : 'view')}/${file.file_id}`"
                    class="d-block"
                    target="_blank"
                    style="border: 1px solid #ccc; max-height: 150px; overflow-y: hidden; background-color: #ffffff;">
                    <img v-bind:src="getThumbnail(file)" class="img-fluid" :ref="`file-${file.file_id}`" />
                </a>

                <div class="text-muted small text-center">
                    {{ file.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }} | {{ file.FirstName }} {{ file.LastName }}
                </div>

                <div v-if="editMode" class="mt-2 mb-1">
                    <b-form-textarea v-model="file.description" :placeholder="`Enter Notes or Description for: ${file.file_name}`" @blur="saveFileDescription(file)" />
                </div>
                <div v-else-if="file.description" class="mt-2 mb-1">
                    {{ file.description }}
                </div>

                <div class="d-print-none" v-if="canEditFile" style="position: absolute;top: 0.5rem;left: 1.25rem;">
                    <router-link :to="`/files/edit/${file.file_id}`" v-if="!file.download_only && $root.canEditFile(file) && false" class="btn btn-sm btn-default" style="background: #ffffff;">
                        <i class="fa fa-edit"></i>
                    </router-link>
                    <a :href="`/files/download/${file.file_id}`" target="_blank" title="Download File/Photo" class="btn btn-sm btn-default" style="background: #ffffff;">
                        <i class="fa fa-download"></i>
                    </a>
                    <a href="javascript:void(0)" class="btn btn-sm btn-default" title="Delete File/Photo" v-on:click="deleteFile(file)" style="background: #ffffff;">
                        <i class="fa fa-trash text-danger"></i>
                    </a>
                </div>
            </div>
        </template>

        <template v-else-if="displayType == 'list2.0'">
            <div class="ui-bordered p-2 mb-lg-1 mb-3" v-for="file in files">
                <div class="row">
                    <div class="col-lg-2 col-md-4 col-sm-6 col-12 mb-sm-0 mb-1">
                        <file-preview :file="file" />
                    </div>
                    <div class="col-lg-10 col-md-8 col-sm-6 col-12">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-12 mb-md-0 mb-1">
                                <a :href="`/files/${(file.download_only ? 'download' : 'view')}/${file.file_id}`" target="_blank">
                                    <strong class="project-attachment-filename" style="color: #333;">{{ file.file_name }}</strong>
                                </a>
                                <div class="text-muted small">
                                    {{ file.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }} | {{ file.FirstName }} {{ file.LastName }}
                                </div>
                                <div class="text-muted small d-print-none" v-if="file.file_size">{{ file.file_size }}</div>
                                <div class="d-print-none">
                                    <template v-if="!file.download_only && false">
                                        <a :href="`/files/view/${file.file_id}`" target="_blank" class="mr-1">View</a> |
                                        <template v-if="canEditFile(file) && canEdit">
                                            <router-link :to="`/files/edit/${file.file_id}`">
                                                <i class="fa fa-edit"></i> Edit
                                            </router-link> |
                                        </template>
                                    </template>
                                    <a :href="`/files/download/${file.file_id}`" target="_blank" class="mx-1">
                                        <i class="fa fa-download"></i> Download
                                    </a>
                                    <template v-if="canEdit">
                                        |
                                        <a href="javascript:void(0)" class="text-danger ml-1" v-on:click="deleteFile(file)" :disabled="deleting_file && deleting_file == file.file_id">
                                            <template v-if="deleting_file && deleting_file == file.file_id">
                                                <i class="fa fa-spin fa-spinner"></i> Deleting
                                            </template>
                                            <template v-else>
                                                <i class="fa fa-trash"></i> Delete
                                            </template>
                                        </a>
                                    </template>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-12">
                                <div v-if="canEdit && editMode">
                                    <b-form-textarea v-model="file.description" :placeholder="`Enter Notes or Description for: ${file.file_name}`" @blur="saveFileDescription(file)" />
                                </div>
                                <div v-else>
                                    {{ file.description }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else v-for="file in files">
            <div v-if="basicView">
                <div>
                    <strong :title="file.file_name">{{ file.file_name.length <= 16 ? file.file_name : file.file_name.slice(0,16)+'...' }} </strong>
                    <span v-if="!file.download_only">
                        <a :href="`/files/view/${file.file_id}`" target="_blank">View</a>&nbsp;|&nbsp;
                    </span>
                    <a :href="`/files/download/${file.file_id}`" target="_blank">Download</a>
                </div>
            </div>
            <div v-else :class="boxSize">
                <div class="project-attachment ui-bordered p-2 mb-1">
                    <a :href="`/files/${(file.download_only ? 'download' : 'view')}/${file.file_id}`" class="project-attachment-img" target="_blank">
                        <img v-bind:src="getThumbnail(file)" class="img-fluid" :ref="`file-${file.file_id}`">
                    </a>
                    <div class="media-body ml-3 align-top">
                        <a :href="`/files/${(file.download_only ? 'download' : 'view')}/${file.file_id}`" target="_blank">
                            <strong class="project-attachment-filename" style="color: #333;">{{ file.file_name }}</strong>
                        </a>
                        <div class="text-muted small">
                            {{ file.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }} | {{ file.FirstName }} {{ file.LastName }}
                        </div>
                        <div class="text-muted small d-print-none" v-if="file.file_size">{{ file.file_size }}</div>
                        <div class="d-print-none">
                            <template v-if="!file.download_only && false">
                                <a :href="`/files/view/${file.file_id}`" target="_blank" class="mr-1">View</a> |
                                <template v-if="canEditFile(file) && canEdit">
                                    <router-link :to="`/files/edit/${file.file_id}`">
                                        <i class="fa fa-edit"></i> Edit
                                    </router-link> |
                                </template>
                            </template>
                            <a :href="`/files/download/${file.file_id}`" target="_blank" class="mx-1">
                                <i class="fa fa-download"></i> Download
                            </a>
                            <template v-if="canEdit">
                                |
                                <a href="javascript:void(0)" class="text-danger ml-1" v-on:click="deleteFile(file)" :disabled="deleting_file && deleting_file == file.file_id">
                                    <template v-if="deleting_file && deleting_file == file.file_id">
                                        <i class="fa fa-spin fa-spinner"></i> Deleting
                                    </template>
                                    <template v-else>
                                        <i class="fa fa-trash"></i> Delete
                                    </template>
                                </a>
                            </template>
                        </div>
                        <div v-if="file.description">
                            {{ file.description }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            files: {
                type: Array,
                required: true
            },
            boxSize: {
                type: String,
                required: false,
                default: 'col-md-12 col-sm-6 col-xs-12',
            },
            basicView: {
                type: Boolean,
                required: false,
                default: false,
            },
            canEdit: {
                type: Boolean,
                required: false,
                default: true,
            },
            displayType: {
                type: String,
                required: false,
                default: null,
            },
            editMode: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                deleting_file: null,
                userTimezone: this.$store.state.user.timezone,
                fileTableColumns: [
                    //'file_id',
                    'file_name',
                    'user_id',
                    //'asset_type',
                    'created_at'
                ],
                fileTableOptions: {
                    headings: {
                        file_id: 'Actions',
                        file_name: 'File Name',
                        user_id: 'Upload By',
                        asset_type: 'Attached To',
                        created_at: 'Created',
                    },
                    perPageValues: [],
                    sortable: ['file_name', 'created_at'],
                    columnsDropdown: false,
                    uniqueKey: 'file_id',
                },
            }
        },

        computed: {

        },

        methods: {

            //Get the thumbnail preview
            getThumbnail(file){
                //Check if thumbnail was set on the backend
                if(file.thumbnail)
                {
                    return file.thumbnail;
                }

                //Setup
                var preview = null;

                //Switch
                switch(file.file_extension.toLowerCase())
                {
                    case 'pdf':
                        preview = '/Images/file-type-pdf_256x256.png';
                        break;
                    case 'docx':
                    case 'doc':
                        preview = '/Images/file-type-docx_256x256.png';
                        break;
                    case 'xls':
                    case 'xlsx':
                        preview = '/Images/file-type-xlsx_256x256.png';
                        break;
                    case 'mp4':
                    case 'avi':
                    case 'mov':
                    case 'mpg':
                    case 'mpeg':
                    case 'flv':
                    case 'webm':
                    case 'mkv':
                    case 'ogv':
                    case 'wmv':
                        preview = '/Images/file-type-video_256x256.png';
                        break;
                    default:
                        //Data should be a path, not a string - we converted those
                        // $path = $this->{$imageDataName};
                        // $type = pathinfo($path, PATHINFO_EXTENSION);
                        // $data = Storage::get($path);
                        // $preview = "data:image/".$type.";base64," . base64_encode($data);
                        this.loadThumbnail(file);

                        //Stop here
                        return '';
                        break;
                }

                //Stop here
                return preview;

                //Set the preview
                //this.$refs['file-' + file.file_id][0].src = preview;
            },

            loadThumbnail(file){
                //Send it
                this.$http.get('files/view/'+file.file_id, {display_type: 'fluid', thumbnail: true})
                    .then(response => {
                        //Sent the ref
                        this.$refs['file-' + file.file_id][0].src = response.data;

                        //Save the response to the file so we do not have to load it on subsequent file loads
                        //file.thumbnail = response.data;
                        for (var i = 0; i < this.files.length; i++)
                        {
                            //Check the ID
                            if(this.files[i].file_id == file.file_id)
                            {
                                //Set the thumbnail
                                this.files[i].thumbnail = response.data;
                            }
                        }
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    });
            },

            saveFileDescription(file){
                //Show the saving helper?

                //Send it
                this.$http.post('files/edit/'+file.file_id, {description: file.description})
                    .then(response => {
                        //Alert the User
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    });
            },

            canEditFile(file){
                //ONLY allow editing images
                var imageExts = ['jpeg', 'jpg', 'png', 'gif', 'tiff'];

                //Check it
                if(imageExts.indexOf(file.file_extension.toLowerCase()) !== -1)
                {
                    return true;
                }

                return false;
            },

            deleteFile(file){
                //Confirm with the user
                if(!confirm('Are you sure you want to delete file: '+file.file_name+'?'))
                {
                    return;
                }

                //Set the flag
                this.deleting_file = file.file_id;

                //Send it
                this.$http.post('/files/delete/'+file.file_id)
                    .then(res => {
                        //Alert the user
                        this.$toastr.success('File Deleted');

                        //Splice the file
                        this.updateFiles(file, true);
                    })
                    .catch(error => {
                        //Log it
                        console.log(error);
                    })
                    .then(() => {
                        //Reset
                        this.deleting_file = null;
                    });
            },

            updateFiles(file, deleteMode = false){
                //Loop and set
                for (var i = this.files.length - 1; i >= 0; i--)
                {
                    //If the IDs match, replace it
                    if(this.files[i].file_id == file.file_id)
                    {
                        //Splice and reset
                        if(deleteMode)
                        {
                            //SPlice only
                            this.files.splice(i, 1);
                        }
                        else
                        {
                            //Splice and replace so reactivity is preserved
                            this.files.splice(i, 1, file);
                        }

                        //Stop here;
                        return;
                    }
                }

                //If it get here, it's a new bid. Push it
                this.files.push(file);
            },
        },

        mounted() {

        }
    }
</script>

<style>
    .project-attachment-file,
    .project-attachment-img {
        display: inline-block;
        -webkit-box-flex: 0;
        flex-grow: 0;
        flex-shrink: 0;
        width: 4rem;
        height: 4rem;
        overflow: hidden;
    }

    .project-attachment-file {
        display: inline-block;
        text-align: center;
        line-height: 4rem;
    }

    .project-attachment .media-body {
        display: inline-block;
    }
</style>
